import { useCallback } from 'react';
import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { showError, showSuccess } from '#shared/lib/toast';
import { updateProductVariantsStatuses } from '../api';
import {
    checkingProductVariantBeforePublishing,
    ProductVariantBeforePublishingError,
} from '../lib/checkingProductVariantBeforePublishing';

type VariantForStatusAction = Pick<OpenApiSchemaProductVariant, 'id' | 'status' | 'price' | 'minimal_price'>;

export function useProductVariantMenuStatusAction(
    variant: VariantForStatusAction | undefined,
    onStatusChanged?: (newStatus: OpenApiSchemaProductVariant['status']) => void
) {
    const { id, status } = variant ?? {};

    return useCallback(async () => {
        if (!id || status === undefined) {
            return;
        }

        const newStatus = status === 'PUBLISHED' ? 'HIDDEN' : 'PUBLISHED';

        try {
            if (newStatus === 'PUBLISHED' && variant) {
                try {
                    checkingProductVariantBeforePublishing(variant);
                } catch (error) {
                    if (error instanceof ProductVariantBeforePublishingError) {
                        showError({ label: error.message });
                    } else {
                        throw error;
                    }

                    return;
                }
            }

            await updateProductVariantsStatuses({
                variant_ids: [],
                target_status: newStatus,
                query: {
                    variant_ids: [id],
                    statuses: ['PUBLISHED', 'HIDDEN'],
                },
            });
            showSuccess(newStatus === 'PUBLISHED' ? 'Товар опубликован' : 'Товар снят с публикации');
            onStatusChanged?.(newStatus);
        } catch (e) {
            showError(
                {
                    label:
                        newStatus === 'PUBLISHED'
                            ? 'Произошла ошибка при публикации товара, попробуйте еще раз'
                            : 'Произошла ошибка при снятии товара с публикации, попробуйте еще раз',
                },
                e
            );
        }
    }, [id, status, variant, onStatusChanged]);
}
